import React, { Dispatch, SetStateAction } from 'react';
import GridFilterItem from '../../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../../../Base/Components/GridFilter/GridFilter';

interface Props {
	setFilter: Dispatch<SetStateAction<object>>;
}

const ManagerInsuranceCompaniesImportModalFilter = ({ setFilter }: Props) => {
	return (
		<GridFilter onChange={setFilter} isFilterOpen={true}>
			<GridFilterItem
				type={GridFilterItemType.FULLTEXT}
				width={340}
				enableAutocomplete
				customLabel='component.caseType.filterFulltext'
			/>
			<GridFilterItem
				type={GridFilterItemType.FIELD_OF_CARE}
				width={340}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default ManagerInsuranceCompaniesImportModalFilter;
